import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as r } from "../chunks/tslib.es6.js";
import { JSONMap as o } from "../core/jsonMap.js";
import { clone as e } from "../core/lang.js";
import { toPt as t } from "../core/screenUtils.js";
import { property as s } from "../core/accessorSupport/decorators/property.js";
import "../core/accessorSupport/ensureType.js";
import { enumeration as i } from "../core/accessorSupport/decorators/enumeration.js";
import { subclass as l } from "../core/accessorSupport/decorators/subclass.js";
import n from "./LineSymbol.js";
import a from "./LineSymbolMarker.js";

var _p;

var h = new o({
  esriSLSSolid: "solid",
  esriSLSDash: "dash",
  esriSLSDot: "dot",
  esriSLSDashDot: "dash-dot",
  esriSLSDashDotDot: "long-dash-dot-dot",
  esriSLSNull: "none",
  esriSLSInsideFrame: "inside-frame",
  esriSLSShortDash: "short-dash",
  esriSLSShortDot: "short-dot",
  esriSLSShortDashDot: "short-dash-dot",
  esriSLSShortDashDotDot: "short-dash-dot-dot",
  esriSLSLongDash: "long-dash",
  esriSLSLongDashDot: "long-dash-dot"
});

var d = _p = /*#__PURE__*/function (_n) {
  _inherits(p, _n);

  var _super = _createSuper(p);

  function p() {
    var _this;

    _classCallCheck(this, p);

    for (var _len = arguments.length, r = new Array(_len), _key = 0; _key < _len; _key++) {
      r[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(r)), _this.type = "simple-line", _this.style = "solid", _this.cap = "round", _this.join = "round", _this.marker = null, _this.miterLimit = 2;
    return _this;
  }

  _createClass(p, [{
    key: "normalizeCtorArgs",
    value: function normalizeCtorArgs(r, o, e, s, i, l) {
      if (r && "string" != typeof r) return r;
      var n = {};
      return null != r && (n.style = r), null != o && (n.color = o), null != e && (n.width = t(e)), null != s && (n.cap = s), null != i && (n.join = i), null != l && (n.miterLimit = t(l)), n;
    }
  }, {
    key: "clone",
    value: function clone() {
      var r;
      return new _p({
        color: e(this.color),
        style: this.style,
        width: this.width,
        cap: this.cap,
        join: this.join,
        miterLimit: this.miterLimit,
        marker: null == (r = this.marker) ? void 0 : r.clone()
      });
    }
  }, {
    key: "hash",
    value: function hash() {
      var r, o;
      return "".concat(_get(_getPrototypeOf(p.prototype), "hash", this).call(this), ".").concat(null == (r = this.color) ? void 0 : r.hash(), ".").concat(this.style, ".").concat(this.cap, ".").concat(this.join, ".").concat(this.miterLimit, ".").concat(null == (o = this.marker) ? void 0 : o.hash());
    }
  }]);

  return p;
}(n);

r([i({
  esriSLS: "simple-line"
}, {
  readOnly: !0
})], d.prototype, "type", void 0), r([s({
  type: h.apiValues,
  json: {
    read: h.read,
    write: h.write
  }
})], d.prototype, "style", void 0), r([s({
  type: ["butt", "round", "square"],
  json: {
    write: {
      overridePolicy: function overridePolicy(r, o, e) {
        return {
          enabled: "round" !== r && (null == e || null == e.origin)
        };
      }
    }
  }
})], d.prototype, "cap", void 0), r([s({
  type: ["miter", "round", "bevel"],
  json: {
    write: {
      overridePolicy: function overridePolicy(r, o, e) {
        return {
          enabled: "round" !== r && (null == e || null == e.origin)
        };
      }
    }
  }
})], d.prototype, "join", void 0), r([s({
  types: {
    key: "type",
    base: null,
    defaultKeyValue: "line-marker",
    typeMap: {
      "line-marker": a
    }
  },
  json: {
    write: !0,
    origins: {
      "web-scene": {
        write: !1
      }
    }
  }
})], d.prototype, "marker", void 0), r([s({
  type: Number,
  json: {
    read: !1,
    write: !1
  }
})], d.prototype, "miterLimit", void 0), d = _p = r([l("esri.symbols.SimpleLineSymbol")], d);
var m = d;
export { m as default };